import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ApplicationRoutes } from "../../../../routes";
import { SuccessScreen } from "../../components";

export const PasswordResetSuccessPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate(`../${ApplicationRoutes.CUSTOMER_SIGNIN}`);
  };

  const handleClose = () => {
    navigate(`../${ApplicationRoutes.CUSTOMER_SIGNIN}`);
  };

  return (
    <SuccessScreen
      title={t("auth.web.passwordResetWasSuccessful")}
      subtitle={t("auth.web.proceedToSignIn")}
      buttonText={t("common.actions.continueKey")}
      onContinue={handleContinue}
      onClose={handleClose}
    />
  );
};